(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  const initializeProsmartInquiry = () => {
    document.querySelectorAll('[data-inquiry-open]').forEach((trigger) => {
      if (trigger.dataset.inquiryBound === 'true') return;

      const dialogId = trigger.getAttribute('aria-controls');
      const dialog = dialogId ? document.getElementById(dialogId) : null;
      if (!dialog) return;

      const closeButton = dialog.querySelector('[data-inquiry-close]');
      const openDialog = () => {
        if (typeof dialog.showModal === 'function') {
          if (!dialog.open) dialog.showModal();
        } else {
          dialog.setAttribute('open', '');
        }
        trigger.setAttribute('aria-expanded', 'true');
        document.documentElement.classList.add('prosmart-inquiry-open');
      };

      const closeDialog = () => {
        if (typeof dialog.close === 'function' && dialog.open) {
          dialog.close();
        } else {
          dialog.removeAttribute('open');
        }
        trigger.setAttribute('aria-expanded', 'false');
        document.documentElement.classList.remove('prosmart-inquiry-open');
      };

      trigger.addEventListener('click', openDialog);
      if (closeButton) closeButton.addEventListener('click', closeDialog);

      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) closeDialog();
      });

      dialog.addEventListener('cancel', (event) => {
        event.preventDefault();
        closeDialog();
      });

      trigger.dataset.inquiryBound = 'true';
      if (dialog.querySelector('[data-inquiry-feedback]')) openDialog();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeProsmartInquiry, { once: true });
  } else {
    initializeProsmartInquiry();
  }

  document.addEventListener('shopify:section:load', initializeProsmartInquiry);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prosmart-faq"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeProsmartFaq = () => {
      document.querySelectorAll('[data-prosmart-faq]').forEach((faq) => {
        if (faq.dataset.faqInitialized === 'true') return;

        const items = Array.from(faq.querySelectorAll('.prosmart-faq__item'));
        if (!items.length) return;

        if (faq.dataset.singleOpen === 'true') {
          items.forEach((item) => {
            item.addEventListener('toggle', () => {
              if (!item.open) return;
              items.forEach((otherItem) => {
                if (otherItem !== item) otherItem.open = false;
              });
            });
          });
        }

        faq.dataset.faqInitialized = 'true';
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeProsmartFaq, { once: true });
    } else {
      initializeProsmartFaq();
    }

    document.addEventListener('shopify:section:load', initializeProsmartFaq);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rich-text"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeFeatureCarousels = () => {
      document.querySelectorAll('[data-feature-carousel]').forEach((carousel) => {
        if (carousel.dataset.featureInitialized === 'true') return;

        const track = carousel.querySelector('[data-feature-track]');
        const items = Array.from(carousel.querySelectorAll('[data-feature-item]'));
        const dots = Array.from(carousel.querySelectorAll('[data-feature-dot]'));
        const previous = carousel.querySelector('[data-feature-prev]');
        const next = carousel.querySelector('[data-feature-next]');

        if (!track || !items.length) return;

        const getActiveIndex = () => {
          const trackLeft = track.getBoundingClientRect().left;
          let activeIndex = 0;
          let closestDistance = Number.POSITIVE_INFINITY;

          items.forEach((item, index) => {
            const distance = Math.abs(item.getBoundingClientRect().left - trackLeft);
            if (distance < closestDistance) {
              closestDistance = distance;
              activeIndex = index;
            }
          });

          return activeIndex;
        };

        const update = () => {
          const isStatic = track.scrollWidth <= track.clientWidth + 1;
          carousel.classList.toggle('is-static', isStatic);

          if (previous) previous.disabled = isStatic || track.scrollLeft <= 1;
          if (next) next.disabled = isStatic || track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;

          const activeIndex = getActiveIndex();
          dots.forEach((dot, index) => {
            const isActive = index === activeIndex;
            dot.classList.toggle('is-active', isActive);
            dot.setAttribute('aria-selected', String(isActive));
          });
        };

        const scrollToItem = (index) => {
          const targetIndex = Math.max(0, Math.min(index, items.length - 1));
          const target = items[targetIndex];
          track.scrollTo({
            left: target.offsetLeft - track.offsetLeft,
            behavior: 'smooth'
          });
        };

        if (previous) previous.addEventListener('click', () => scrollToItem(getActiveIndex() - 1));
        if (next) next.addEventListener('click', () => scrollToItem(getActiveIndex() + 1));
        dots.forEach((dot, index) => dot.addEventListener('click', () => scrollToItem(index)));

        let updateTimer;
        track.addEventListener(
          'scroll',
          () => {
            window.clearTimeout(updateTimer);
            updateTimer = window.setTimeout(update, 80);
          },
          { passive: true }
        );
        window.addEventListener('resize', update);
        carousel.dataset.featureInitialized = 'true';
        update();
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeFeatureCarousels, { once: true });
    } else {
      initializeFeatureCarousels();
    }

    document.addEventListener('shopify:section:load', initializeFeatureCarousels);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["why-choose"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('prosmart-why-choose')) {
    class ProsmartWhyChoose extends HTMLElement {
      connectedCallback() {
        this.counters = Array.from(this.querySelectorAll('[data-counter]'));
        this.duration = Number(this.dataset.animationDuration) || 1600;
        this.useGrouping = this.dataset.useGrouping === 'true';
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.counters.forEach((counter) => {
          const target = this.getTarget(counter);
          counter.textContent = this.formatValue(target, counter);
        });

        if (this.dataset.animationEnabled !== 'true' || this.reduceMotion || !('IntersectionObserver' in window)) {
          return;
        }

        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              this.animateAll();
              this.observer.disconnect();
            });
          },
          { threshold: 0.25 }
        );

        this.observer.observe(this);
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.frameId) cancelAnimationFrame(this.frameId);
      }

      getTarget(counter) {
        const value = Number(counter.dataset.target);
        return Number.isFinite(value) ? value : 0;
      }

      formatValue(value, counter) {
        const decimals = Math.max(0, Number(counter.dataset.decimals) || 0);
        return new Intl.NumberFormat(document.documentElement.lang || 'en', {
          useGrouping: this.useGrouping,
          minimumFractionDigits: decimals,
          maximumFractionDigits: decimals
        }).format(value);
      }

      animateAll() {
        if (this.hasAnimated) return;
        this.hasAnimated = true;
        const startTime = performance.now();

        const update = (currentTime) => {
          const progress = Math.min((currentTime - startTime) / this.duration, 1);
          const eased = 1 - Math.pow(1 - progress, 4);

          this.counters.forEach((counter) => {
            const target = this.getTarget(counter);
            const decimals = Math.max(0, Number(counter.dataset.decimals) || 0);
            const precision = Math.pow(10, decimals);
            const current = Math.round(target * eased * precision) / precision;
            counter.textContent = this.formatValue(current, counter);
          });

          if (progress < 1) {
            this.frameId = requestAnimationFrame(update);
            return;
          }

          this.counters.forEach((counter) => {
            counter.textContent = this.formatValue(this.getTarget(counter), counter);
            const number = counter.closest('.prosmart-why-choose__number');
            if (number) number.classList.add('is-complete');
          });
        };

        this.frameId = requestAnimationFrame(update);
      }
    }

    customElements.define('prosmart-why-choose', ProsmartWhyChoose);
  }

  } catch(e) { console.error(e); }
})();
})();
